<template>
  <v-card :class="{ 'disabled-card': !isCompetitionActive }">
    <v-card-title>
      <v-row>
        <v-col cols="12" class="d-flex justify-start">
          <h3>
            {{ competition.name }}
          </h3>
          <v-icon v-if="competition.isRegister" color="green" class="ml-2"
            >mdi-check-circle</v-icon
          >
          <span v-if="competition.isRegister">Regisztrálva</span>
          <v-icon v-if="competition.isDone" color="green" class="ml-2"
            >mdi-check-circle</v-icon
          >
          <span v-if="competition.isDone">Befejezve</span>
          
        </v-col>
      </v-row>
    </v-card-title>

    <v-row>
      <v-col cols="8">
        <MdPreview
          editorId="md_text"
          :modelValue="competition.shortDescription"
          style="word-break: normal; text-align: start"
        />
      </v-col>
      <v-col cols="4" style="align-content: flex-end; margin-bottom: 12px">
        <v-row>
          <v-col cols="12" class="d-flex justify-start">
            <strong>Kitöltés kezdete:</strong>
            {{ formatDate(competition.fillableFrom) }}
          </v-col>
          <v-col cols="12" class="d-flex justify-start">
            <strong>Kitöltés vége:</strong>
            {{ formatDate(competition.fillableTo) }}
          </v-col>
          <v-col cols="12" class="d-flex justify-start">
            <v-btn
              @click="goToPage1"
              v-if="competition.isRegister"
              :disabled="!isCompetitionActive"
              color="rsz500"
              class="mr-2"
              >Kitöltés</v-btn
            >
            <v-btn
              @click="goToPage2"
              :disabled="!isCompetitionActive"
              v-if="competition.isRegister"
              color="rsz500"
              class="mr-2"
              >Csapat</v-btn
            >
            <v-btn
              @click="registerTeam"
              v-if="!competition.isRegister"
              :disabled="!isCompetitionActive"
              color="rsz500"
              class="mr-2"
              >Regisztráció</v-btn
            >
            <v-btn
              @click="showReading"
              v-if="competition.isRegister"
              :disabled="!isCompetitionActive"
              color="rsz500"
              class="mr-2"
              >Ajánlott irodalom</v-btn
            >
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-card>

  <v-dialog v-model="shouldShowReading" max-width="700px">
    <v-card>
      <v-card-text>
        <MdPreview
          editorId="md_text"
          :modelValue="competition.reading"
          style="word-break: normal; text-align: start"
        />
      </v-card-text>
      <v-card-actions>
        <v-btn @click="hideReading">Kilép</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>
import { MdPreview } from 'md-editor-v3'
import 'md-editor-v3/lib/preview.css'

export default {
  name: 'CompetitionsCard',
  components: {
    MdPreview,
  },
  data: () => {
    return {
      shouldShowReading: false,
    }
  },
  props: {
    registerTeam: {
      type: Function,
      required: true,
    },
    competition: {
      type: Object,
      required: true,
      default: () => ({
        name: '',
        id: '',
        shortDescription: '',
        fillableFrom: null,
        fillableTo: null,
        isTeam: false,
        isRegister: false,
        reading: '',
        isDone: false,
      }),
    },
  },
  computed: {
    isCompetitionActive() {
      const now = new Date()
      const fillableFrom = new Date(this.competition.fillableFrom)
      const fillableTo = new Date(this.competition.fillableTo)
      return now >= fillableFrom && now <= fillableTo && !this.competition.isDone
    },
  },
  methods: {
    formatDate(date) {
      const options = { year: 'numeric', month: 'long', day: 'numeric'}
      return new Date(date).toLocaleTimeString(undefined, options)
    },
    goToPage1() {
      this.$router.push({
        name: 'tasks',
        params: { competitionId: this.competition.id },
      })
    },
    goToPage2() {
      this.$router.push({
        name: 'team',
        params: { competitionId: this.competition.id },
      })
    },
    showReading(){
      this.shouldShowReading = true
    },
    hideReading(){
      this.shouldShowReading = false
    },
  },
  mounted: () => {
    document.getElementById('md_text-preview').style.wordBreak = 'normal'
  },
}
</script>

<style>
.disabled-card {
  background-color: #e0e0e0;
  pointer-events: none;
  opacity: 0.6;
}
</style>
